import fieldMixin from '@phoenix/mixins/fieldMixin';

export default {
  mixins: [fieldMixin],

  inject: {
    shouldDisplayFilledCheckmark: {
      default: false,
    },
  },

  computed: {
    isFilled() {
      return this.shouldDisplayFilledCheckmark && this.isDirty && !this.isInvalid;
    },

    fieldClasses() {
      return [
        'input',
        this.fieldClass,
        {
          'input--filled': this.isFilled,
        },
      ];
    },
  },
};
